// db.js
import Dexie from 'dexie'

const db = new Dexie('myDatabase')// 数据库名称：myDatabase
db.version(1).stores({
  imgStore: 'id, imgBs64'
})
db.version(2).stores({
  ccStore: 'id, data'
})

export { db }



// WEBPACK FOOTER //
// ./src/utils/db.js